import React from "react";
import ConfettiComponent from "../Kanban/ConfettiComponent";
import LoginButton from "./LoginButton";
import "./LoginStyle.css";

export default function LoginComponent() {
  // Function used to save the google profile data to 
  // localstorage
  const googleResponse = (res) => {
    console.log(res.profileObj);
    localStorage.setItem("profile", JSON.stringify(res.profileObj));
    if (res.profileObj) window.location.reload();
  };
  return (
    <>
      <ConfettiComponent open={true} />
      <div className="login flex-center">
        <div className="login-wrap">
          <div className="welcome-message flex-center">
            <span className="s-title">Welcome To</span>
            <span className="l-title text-clip text-gradient-anim">
              Project <span className="bg-text">Manager</span>
            </span>
          </div>
          <div className="login-box flex-center">
            <LoginButton res={googleResponse} />
          </div>
        </div>
      </div>
    </>
  );
}
